import { render, staticRenderFns } from "./switcherADisabledIcon.vue?vue&type=template&id=558ad100&"
import script from "./switcherADisabledIcon.vue?vue&type=script&lang=js&"
export * from "./switcherADisabledIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports